<template>
  <div class="maintenance-subtitle">
    <span><strong>{{ $t('in-progress-maintenance-subtitle-part-one') }}</strong></span>
    <span>{{ $t('in-progress-maintenance-subtitle-part-two') }}</span>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
.maintenance-subtitle {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
  color: $bodyText;
  max-width: 396px;
  margin: 0;
}
</style>


